export const getUser = () => {
  let userId = localStorage.getItem("user_id");
  if (userId) {
    userId = parseInt(userId, 10);
  }
  return userId;
};

export const getReadingTime = (words) => {
  return Math.floor(words / 200) + 1;
};
